import { MailOutlined } from "@ant-design/icons";
import styled from "styled-components";

const StyledMailOutlined = styled(MailOutlined)`
  color: lightgray;
  cursor: pointer;
`;

function MessageNavigationIcon() {
  return (
    // <Badge dot={unreadCount > 0}>
    <StyledMailOutlined />
    // </Badge>
  );
}

export default MessageNavigationIcon;
